module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "slide"
    }
  }, [(_vm.isLoaded && !_vm.atualizadoSucesso) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "bg-light lter b-b wrapper-md"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('h1', {
    staticClass: "m-n font-thin h3"
  }, [_vm._v("Bloqueio de GRV para leilão")])])])]), _vm._v(" "), _c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [(_vm.cadastroError !== null) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-danger",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "m-b-sm font-bold"
  }, [_vm._v("Erro ao bloquear GRV")]), _vm._v(" "), _vm._l((_vm.cadastroError), function(erro, key) {
    return _c('p', [_vm._v(_vm._s(_vm.printError(erro)))])
  })], 2) : _vm._e(), _vm._v(" "), _c('a', {
    ref: "sucessMsg",
    attrs: {
      "name": "sucessMsg",
      "id": "sucessMsg",
      "href": "javascript:void(0)"
    }
  }), _vm._v(" "), (_vm.atualizadoSucesso !== null && _vm.atualizadoSucesso) ? _c('div', {
    ref: "error",
    staticClass: "alert alert-success",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "font-bold"
  }, [_vm._v("Excluído com sucesso!")])]) : _vm._e(), _vm._v(" "), _c('h4', [_vm._v("Atenção!")]), _vm._v(" "), (_vm.isBloqueado) ? _c('small', [_vm._v("A GRV foi bloqueada para leilões em " + _vm._s(_vm._f("formatDate")(_vm.data.dataBloqueio.date, 'DD/MM/YYYY HH:mm')) + " pelo seguinte motivo:\n            "), _c('br'), _c('br'), _vm._v("\n            " + _vm._s(_vm.motivoBloqueio) + "\n          ")]) : _c('small', [_vm._v("A GRV selecionada não poderá ser utilizada para criação de lote.")]), _vm._v(" "), (_vm.data.lotes.length) ? _c('hr') : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('h4', {
    staticClass: "m-b-lg"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle text-danger"
  }), _vm._v(" Esta GRV está ligada aos seguintes leilões:")]) : _vm._e(), _vm._v(" "), (_vm.data.lotes.length) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('ul', {
    staticClass: "list-unstyled l-h-2x"
  }, _vm._l((_vm.data.lotes), function(lote) {
    return _c('li', [_vm._v("Lote "), _c('strong', [_vm._v(_vm._s(lote.lote))]), _vm._v(" no leilão "), _c('strong', [_vm._v(_vm._s(lote.tituloLeilao))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (!_vm.isBloqueado) ? _c('hr') : _vm._e(), _vm._v(" "), (!_vm.impedirBloqueio && !_vm.isBloqueado) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {}, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.motivoBloqueio),
      expression: "motivoBloqueio",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    staticStyle: {
      "max-height": "50px"
    },
    attrs: {
      "rows": "4",
      "placeholder": "Motivo do bloqueio"
    },
    domProps: {
      "value": (_vm.motivoBloqueio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.motivoBloqueio = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.impedirBloqueio) ? _c('div', {
    staticClass: "row wrapper"
  }, [_c('u-button', {
    staticClass: "btn m-b-xs w-auto btn-danger m-r-xs",
    attrs: {
      "disabled": _vm.isSemMotivo
    },
    on: {
      "click": _vm.bloquearGrvParaLeilao
    }
  }, [(_vm.isBloqueado) ? _c('span', [_vm._v("Desbloquear")]) : _c('span', [_vm._v("Confirmar bloqueio")])]), _vm._v(" "), _c('u-button', {
    staticClass: "btn m-b-xs w-xs m-r-xs btn-default",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancelar")])], 1) : _vm._e()])])])]) : (_vm.atualizadoSucesso) ? _c('div', {
    staticClass: "content-transition"
  }, [_c('div', {
    staticClass: "wrapper-md"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle fa-5x text-success"
  }), _vm._v(" "), _c('h4', {
    staticClass: "m-t-lg"
  }, [_vm._v("Grv bloqueada com sucesso!")])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c4fbfdf","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/BloquearGrvLeilaoAlerta.vue
// module id = 1985
// module chunks = 2